<div class="mb-3" *ngIf="!field.hide && !to.hidden && !isEmptyOptionalSelect()">
    <label
        [attr.for]="key"
        class="form-control-label {{
            to && to.labelClass ? to.labelClass : ''
        }}"
    >
        {{ to.label }}{{ to.label && to.required ? "*" : "" }}
        <span class="tt" *ngIf="to.title">
            <fa-icon class="ms-2" [icon]="faInfoSign"></fa-icon>
            <span class="tttext">{{ to.title }}</span>
        </span>
    </label>
    <div *ngIf="to && to.topNote" class="field-notes">
        <sub [innerHTML]="to.topNote"></sub>
    </div>
    <div
        [hidden]="to.isUrl"
        class="{{ to && to.entityClass ? to.entityClass : '' }}"
        [class.field-has-error]="showError && !to.loading"
    >
        <ng-template #fieldComponent autocomplete="nope"></ng-template>
    </div>
    <div
        *ngIf="to.isUrl"
        class="{{ to && to.entityClass ? to.entityClass : '' }}"
    >
        <a class="btn-link" [href]="formControl.value" target="_blank">{{
            formControl.value
        }}</a>
    </div>
    <!-- Not while loading: a file field reloading its list after a page switch is briefly empty,
         which flashed the required error before its files arrived. -->
    <div *ngIf="showError && !to.loading" class="invalid-feedback" style="display: block;">
        <formly-validation-message [field]="field"></formly-validation-message>
    </div>
    <div *ngIf="to && to.note" class="field-notes">
        <sub [innerHTML]="to.note"></sub>
    </div>
</div>
